export default __webpack_public_path__ + "d45464579ee56dbef317db2deeb83f82.png";